<template>
	<div class="multi-format-aspect-ratio-selector">
		<div
			class="multi-format-aspect-ratio-selector__options"
			:aria-label="$I18n.trans_choice('spotlight.graphics.format', 1)"
		>
			<button
				v-for="option in options"
				:key="option.value"
				type="button"
				class="multi-format-aspect-ratio-selector__button"
				:class="{ 'is-active': option.value === value }"
				:disabled="disabled"
				@click="$emit('change', option.value)"
			>
				{{ option.label }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name:  'MultiFormatAspectRatioSelector',
	props: {
		value: {
			type:    String,
			default: null,
		},
		options: {
			type:    Array,
			default: () => [],
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.multi-format-aspect-ratio-selector {
	width: 100%;
}

.multi-format-aspect-ratio-selector__options {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: $sp3;
}

.multi-format-aspect-ratio-selector__button {
	@include font-size(fs-80);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 62px;
	height: 42px;
	padding: 0 $sp3;
	border: 1px solid var(--color-grey-600);
	border-radius: $border-radius--sm;
	color: var(--color-grey-050);
	background-color: transparent;
	cursor: pointer;
	transition: border-color $trans-time-fast, background-color $trans-time-fast, color $trans-time-fast;

	&:hover,
	&:focus {
		border-color: var(--color-grey-400);
		background-color: transparent;
	}

	&.is-active {
		border-color: var(--color-hype-yellow);
		background-color: transparent;
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
}
</style>
